import React, { MouseEventHandler } from 'react';
import Image from 'next/image';
import close from '@assets/images/close-navigation.svg';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export default function CloseButton({ onClick }: Props) {
  return (
    <button
      onClick={onClick}
      type="button"
      className="h-5 w-5 flex-shrink-0 relative border border-rp-gray-divider rounded-full cursor-pointer"
    >
      <div className="h-3 w-3 mx-auto flex justify-center items-center">
        <Image src={close} alt="close" />
      </div>
    </button>
  );
}
